module.exports = __webpack_public_path__ + "img/google-play-badge-us.a5795700.svg";